import script from "./ModalAsideBody.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalAsideBody.vue?vue&type=script&lang=ts&setup=true"

import "./ModalAsideBody.vue?vue&type=style&index=0&id=bd75fe6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd75fe6c"]])

export default __exports__